<script lang="ts">
  import Button from 'Catalyst/components/Button/Button.svelte';
  import AppleIcon from 'Components/SocialLogin/icons/AppleIcon.svelte';
  import FacebookIcon from 'Components/SocialLogin/icons/FacebookIcon.svelte';
  import GoogleIcon from 'Components/SocialLogin/icons/GoogleIcon.svelte';

  export let googleAuthPath: string;
  export let appleAuthPath: string;
  export let facebookAuthPath: string;

  const authProviders = [
    {
      icon: GoogleIcon,
      name: 'google',
      authPath: googleAuthPath,
    },
    {
      icon: AppleIcon,
      name: 'apple',
      authPath: appleAuthPath,
    },
    {
      icon: FacebookIcon,
      name: 'facebook',
      authPath: facebookAuthPath,
    },
  ];
</script>

{#each authProviders as provider}
  <form
    data-testid={`social-login-form-${provider.name}`}
    class="w-full flex flex-col mb-0"
    action={provider.authPath}
    method="post"
  >
    <Button
      style="tonal"
      type="submit"
      size="lg"
      data-testid={`social-login-button-${provider.name}`}
    >
      <span>Continue with</span>
      <svelte:component this={provider.icon} />
    </Button>
  </form>
{/each}
